import { Component, EventEmitter, Injector, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { environment } from '../../../environments/environment';
import { GTM } from 'src/app/services/gtm.service';
import { CreateCustomer } from 'src/app/services/kingfisher/create-customer';
import { HbmApiService } from 'src/app/services/hbm/hbm-api.service';
import { Country, otherCountries, prioCountries } from 'src/app/services/kingfisher/countries';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Customer, HonorificPrefix, PagedCustomerResponse } from 'src/app/services/kingfisher/customer';
import { VendorService } from 'src/app/services/vendor.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { FidelityService } from 'src/app/services/fidelity/fidelity.service';
import { UpdateCustomerComplete } from 'src/app/services/fidelity/update-customer-fidelity';
import { IsNewTenantCh, MemberTypeCh } from 'src/app/services/fidelity/fidelity';
import { AddFidelityCardCustomer, InfoReturnCreateFidelityCard } from 'src/app/services/fidelity/create-fidelity-card';
import { PaytweakRequestInput } from 'src/app/services/fidelity/paytweak';
import { BehaviorSubject } from 'rxjs';
import { VALIDATION_COMPONENT_TYPE_ENUM } from '../../pages/validation/validation.component';
import { StatisticService } from 'src/app/services/statistic.service';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { TunnelDataStore } from '../../stores/tunnel/tunnel-data.store';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { FidelitySubscribeStoreService } from 'src/app/pages/fidelity/fidelity-subscribe/services/fidelity-subscribe.store.service';
import { FeatureSettingsService } from '../../services/feature-settings/feature-settings.service';

const { required } = Validators;
const regexPhoneNumber = /^(0[6-9](?!0{8})\d{8})|(\+\d{7,12})?$/;
export const regexPostalCode = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;

@Component({
  selector: 'ng-casto-register',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  private readonly KEY_TOAST = 'register';

  /* FROM personal-informations.component.ts du projet Fidélité */
  private emailExists: boolean = false;
  private customerInfo: Customer;
  private hasCard: boolean = false;
  private cities: string[];

  public prioCountries: Country[] = prioCountries;
  public otherCountries: Country[] = otherCountries;
  public emailLoading: boolean = false;
  public form: FormGroup;
  public emailSearched: string;
  public isEmailSearched: boolean = false;

  /*LEGACY*/
  public isVendor = environment.vendor;
  public inputs: any;
  public isLoading: boolean;
  public globalError: string = '';
  public showBackToLogin: boolean;

  public readonly HonorificPrefix = HonorificPrefix;
  public showChoiceCustomer: boolean = false;
  statisticType: StatisticTypeEnum;
  /*attributes from currentDatas */
  private loadData: boolean = false;
  public updateData: boolean = false;
  private defaultEmail?: string;
  public createCard: boolean = false;
  public withPremium: boolean = false;
  public withFree: boolean = false;
  public cardIsPremiumInit: boolean = false;
  public updateDataValidation: boolean = false;
  public refreshEmailSubject: BehaviorSubject<string>;
  public refreshValidationRequested: EventEmitter<VALIDATION_COMPONENT_TYPE_ENUM> = new EventEmitter();
  loginCallBack: Function;
  registerCallback: Function;

  get civilityIndex() {
    return Object.values(HonorificPrefix).indexOf(this.form.get('honorificPrefix').value);
  }

  get civilityValue() {
    return this.form.get('honorificPrefix').value;
  }

  get birthdateDate(): Date {
    return this.form.get('birthDate').value ? new Date(this.form.get('birthDate').value) : null;
  }

  get withFidelityCard(): boolean {
    return this.form.get('withFidelityCard').value;
  }

  get country() {
    return this.form.get('country');
  }

  get cardIsPremium() {
    return this.form.get('cardIsPremium').value;
  }

  constructor(
    public modalService: ModalService,
    private readonly customer: CustomerService,
    private readonly gtm: GTM,
    private readonly hbmService: HbmApiService,
    private readonly injector: Injector,
    private readonly tunnelDataStore: TunnelDataStore,
    private readonly fidelitySubscribeStoreService: FidelitySubscribeStoreService,
    private readonly featureSettingsService: FeatureSettingsService
  ) {}

  close() {
    this.onClose(false);
  }

  ngOnInit(): void {
    if (!this.modalService.currentDatas.updateDataValidation) {
      this.customer.logout();
      this.gtm.trackEvent('s-enregistrer');
    }
    this.showBackToLogin = !environment.vendor;
    this.initFormCurrentDatas();
    this.initForm();
  }

  initFormCurrentDatas() {
    if (this.modalService.currentDatas) {
      this.registerCallback = this.modalService.currentDatas.registerCallback;
      this.loginCallBack = this.modalService.currentDatas.loginCallBack;
      this.defaultEmail = this.modalService.currentDatas.defaultEmail;
      this.loadData = this.modalService.currentDatas.loadData;
      this.updateData = this.modalService.currentDatas.updateData;
      this.createCard = this.modalService.currentDatas.createCard;
      this.withPremium = this.modalService.currentDatas.withPremium;
      this.withFree = this.modalService.currentDatas.withFree;
      this.cardIsPremiumInit = this.modalService.currentDatas.cardIsPremium;
      this.updateDataValidation = this.modalService.currentDatas.updateDataValidation;
      this.refreshEmailSubject = this.modalService.currentDatas.refreshEmailSubject;
      this.refreshValidationRequested = this.modalService.currentDatas.refreshValidationRequested;
      this.statisticType = this.modalService.currentDatas.statisticType;
    }
  }

  setAddressRequired(condition: boolean) {
    if (condition || this.cardIsPremiumInit) {
      this.form.get('postalCode').addValidators(Validators.required);
      this.form.get('country').addValidators(Validators.required);
      this.form.get('city').addValidators(Validators.required);
      this.form.get('address').addValidators(Validators.required);
      this.form.get('houseNumber').addValidators(Validators.required);
    } else {
      this.form.get('postalCode').clearValidators();
      this.form.get('country').clearValidators();
      this.form.get('city').clearValidators();
      this.form.get('address').clearValidators();
      this.form.get('houseNumber').clearValidators();
    }

    this.form.get('postalCode').updateValueAndValidity();
    this.form.get('country').updateValueAndValidity();
    this.form.get('city').updateValueAndValidity();
    this.form.get('address').updateValueAndValidity();
    this.form.get('houseNumber').updateValueAndValidity();
  }

  initCountryForm() {
    //Quand tu choisis un pays, si c'est la france, tu fait en sorte de valider des téléphones français et des codes postaux français, sinon tu remet les validateurs de base (required)
    this.form.get('country').valueChanges.subscribe(country => {
      if (country === 'FR') {
        this.form.get('phoneNumber').addValidators(Validators.pattern(regexPhoneNumber));
        this.form.get('postalCode').addValidators(Validators.pattern(regexPostalCode));
      } else {
        this.form.get('phoneNumber').removeValidators(Validators.pattern(regexPhoneNumber));

        this.form.get('postalCode').removeValidators(Validators.pattern(regexPostalCode));
      }

      this.form.get('phoneNumber').updateValueAndValidity();
      this.form.get('postalCode').updateValueAndValidity();
    });
  }

  initEmailForm() {
    let timeoutHandle: any;
    this.form.get('email').valueChanges.subscribe(x => {
      if (x !== this.emailSearched) {
        this.isEmailSearched = false;
        this.form.get('phoneNumber').setValue(null);
        this.form.get('honorificPrefix').setValue(null);
        this.form.get('honorificPrefix').disable();
        this.form.get('lastName').setValue(null);
        this.form.get('firstName').setValue(null);
        this.form.get('postalCode').setValue(null);
        this.form.get('city').setValue(null);
        this.form.get('houseNumber').setValue(null);
        this.form.get('address').setValue(null);
        this.form.get('country').disable();
        this.form.get('localityPoBox').setValue(null);
        this.form.get('buildingFloorStaircase').setValue(null);
        this.form.get('birthDate').setValue(null);
      } else {
        this.isEmailSearched = true;
        this.enableCivilityAndCountry();
      }

      if (timeoutHandle) {
        window.clearTimeout(timeoutHandle);
      }

      timeoutHandle = setTimeout(() => {
        if (this.form.get('email').valid) {
          this.searchMail();
        }
      }, 1000);
    });
  }

  initWithFidelityCardForm() {
    this.form.get('withFidelityCard').valueChanges.subscribe(withFidelityCard => {
      this.showChoiceCustomer = withFidelityCard;
    });
  }

  initCardIsPremiumForm() {
    this.form.get('cardIsPremium').valueChanges.subscribe(cardIsPremium => {
      this.setAddressRequired(cardIsPremium);
    });
  }

  initForm() {
    this.createForm();
    this.initCountryForm();
    this.initEmailForm();
    this.initWithFidelityCardForm();
    this.initCardIsPremiumForm();
    this.setAddressRequired(this.cardIsPremiumInit);

    if (this.form.get('city').value && this.form.get('city').value.length > 0) {
      this.cities = [this.form.get('city').value];
    }

    if (this.defaultEmail || this.form.get('email').value) {
      this.searchMail();
    }
  }

  createForm() {
    let formBuilder = this.injector.get(FormBuilder);
    let formControl = {
      email: [this.defaultEmail ? this.defaultEmail : null, [Validators.email, Validators.required]],
      phoneNumber: [null, [Validators.required]],
      honorificPrefix: [{ value: null, disabled: true }, [Validators.required]],
      lastName: [null, [Validators.required]],
      firstName: [null, [Validators.required]],
      houseNumber: ['', [Validators.maxLength(10)]],
      address: [''],
      postalCode: [''],
      city: [''],
      birthDate: [null],
      country: [{ value: prioCountries[0].value, disabled: true }],
      localityPoBox: [''],
      buildingFloorStaircase: [''],
      withFidelityCard: [false],
      newMoveIn: [false],
      lastMoveInDate: [null],
      siret: [null],
      nTvaIntracommunautaire: [{ value: null, disabled: false }],
      memberType: [MemberTypeCh.NonRenseigne],
      cardIsPremium: [this.cardIsPremiumInit],
    };

    this.form = formBuilder.group(formControl);
  }

  enableCivilityAndCountry() {
    if (this.form.enabled) {
      this.form.get('honorificPrefix').enable();
      this.form.get('country').enable();
    }
  }

  setFormValue(customer: Customer) {
    this.form.get('phoneNumber').setValue(customer.phoneNumber);
    this.form.get('honorificPrefix').setValue(customer.honorificPrefix);
    this.form.get('lastName').setValue(customer.lastname);
    this.form.get('firstName').setValue(customer.firstname);
    this.form.get('houseNumber').setValue(customer.address?.num);
    this.form.get('address').setValue(customer.address?.line1);
    this.form.get('postalCode').setValue(customer.address?.postalCode);
    this.form.get('city').setValue(customer.address?.city);
    this.form.get('country').setValue(customer.address?.country ?? prioCountries[0].value);
    this.form.get('birthDate').setValue(customer.dateOfBirth ?? null);
    this.form.get('localityPoBox').setValue(customer.address?.complement);
    this.form.get('buildingFloorStaircase').setValue(customer.address?.line2);
    this.customerInfo = customer;
  }

  async searchMailVendor() {
    const vendorService = this.injector.get(VendorService);

    let customers: PagedCustomerResponse = await vendorService.searchCustomers({
      email: this.form.controls['email'].value,
      first: 1, //valeur par défaut validation, à voir pour trouver mieux
    });

    let customer = customers.customers[0];

    if (customer) {
      //L'adresse mail recherchée existe déjà en base
      this.emailExists = true;

      if (this.loadData) {
        this.setFormValue(customer);
        this.enableCivilityAndCountry();

        this.emailSearched = this.form.get('email').value;
        this.isEmailSearched = true;
        this.form.get('email').disable();
      } else {
        this.form.get('email').setErrors({ taken: true });
      }
    } else {
      //L'adresse mail n'existe pas en base
      this.customerInfo = undefined;
      this.emailExists = false;
      this.hasCard = false;
      this.enableCivilityAndCountry();
      this.emailSearched = this.form.get('email').value;
      this.isEmailSearched = true;
    }

    this.emailLoading = false;
  }

  /**
   * Fonction de recherche de l'adresse mail dans la base KF
   FROM personal-informations.component.ts du projet Fidélité
   */
  async searchMail() {
    if (this.form.get('email').valid && !this.isEmailSearched) {
      this.emailLoading = true;
      this.searchMailVendor();
    } else {
      this.enableCivilityAndCountry();
    }
  }

  /**
   * Détermine si le champs est obligatoire ou non
   FROM personal-informations.component.ts du projet Fidélité
   * @param id id du champ du formulaire
   * @returns boolean
   */
  isRequired(id: string): boolean {
    return this.form.controls[id]?.hasValidator(required);
  }

  login() {
    this.modalService.display(MODAL.LOGIN);
  }

  isFormValid() {
    return this.form.valid;
  }

  onClose(isSearchUntilFind: boolean = true) {
    if (this.refreshEmailSubject) {
      this.refreshEmailSubject.next(this.emailSearched);
    }

    if (this.refreshValidationRequested) {
      this.refreshValidationRequested.emit();
    }

    if (this.loginCallBack) {
      this.loginCallBack();
    } else if (this.registerCallback) {
      this.setupReturnToSearch(isSearchUntilFind);
      this.registerCallback();
    } else {
      this.modalService.close();
    }
  }

  buildAddFidelityCardCustomerInput(): AddFidelityCardCustomer {
    let addFidelityCardCustomer: AddFidelityCardCustomer = {
      civility: this.civilityIndex,
      lastName: this.form.get('lastName').value,
      firstName: this.form.get('firstName').value,
      email: this.form.get('email').value,
      phoneNumber: this.form.get('phoneNumber').value,
      houseNumber: this.form.get('houseNumber').value,
      address: this.form.get('address').value,
      buildingFloorStaircase: this.form.get('buildingFloorStaircase').value,
      localityPoBox: this.form.get('localityPoBox').value,
      postalCode: this.form.get('postalCode').value,
      city: this.form.get('city').value,
      country: this.form.get('country').value,
      birthdate: this.birthdateDate,
      memberType: this.createCard ? this.form.get('memberType').value : MemberTypeCh.NonRenseigne,
      cardIsPremium: this.createCard ? this.form.get('cardIsPremium').value : false,
      newMoveIn: this.createCard ? this.form.get('newMoveIn').value : false,
      //pas encore save depuis le formulaire

      isNewTenantCh: IsNewTenantCh.No,
      habitationType: 0,
      customerPropertySituation: 0,
      marketingConsent: {
        optinEmail: true,
        optinSms: true,
        optinPhone: true,
        optoutPostal: true,
      },
      siret: '',
      nTvaIntracommunautaire: '',
      projectNext6Months: {
        kitchen: false,
        bathroom: false,
        floorAndWall: false,
        insulation: false,
        storage: false,
        outdoor: false,
      },
      companyName: '',
    };

    return addFidelityCardCustomer;
  }

  buildUpdateCustomerInput(): UpdateCustomerComplete {
    let updateCustomer: UpdateCustomerComplete = {
      customerIdKf: this.customerInfo.kfId,
      ...this.buildAddFidelityCardCustomerInput(),
    };

    return updateCustomer;
  }

  async submit() {
    const shouldCreateFidelityCard = this.createCard || this.withFidelityCard;

    if (this.updateData) {
      await this.update();
    } else if (shouldCreateFidelityCard && await this.featureSettingsService.isFidelityEnabled()) {
      await this.createFidelityCard();
    } else if (shouldCreateFidelityCard && this.customerInfo) {
      this.onClose(false);
    } else {
      await this.register();
    }

    if (this.customer.userDatas) {
      await this.tunnelDataStore.loadCurrentCustomer(this.customer.userDatas);
    }
  }

  async register() {
    const translateService = this.injector.get(TranslateService);
    this.isLoading = true;
    if (this.isFormValid()) {
      const date = new Date().toISOString().replace('Z', '');
      const data: CreateCustomer = {
        honorificPrefix: this.form.get('honorificPrefix').value,
        email: this.form.get('email').value,
        familyName: this.form.get('lastName').value,
        givenName: this.form.get('firstName').value,
        phoneNumber: this.form.get('phoneNumber').value,
        dateOfBirth: this.form.get('birthDate').value ?? null,
        address: {
          num: this.form.get('houseNumber').value,
          line1: this.form.get('address').value,
          line2: this.form.get('buildingFloorStaircase').value,
          complement: this.form.get('localityPoBox').value,
          postalCode: this.form.get('postalCode').value,
          city: this.form.get('city').value,
          country: this.form.get('country').value,
        },
        marketingChannels: [
          {
            channel: 'sms',
            optIn: false,
            submitted: date,
            privacyPolicyVersionId: '1',
            marketingChannelVersionId: '2',
          },
          {
            channel: 'phone',
            optIn: false,
            submitted: date,
            privacyPolicyVersionId: '1',
            marketingChannelVersionId: '2',
          },
          {
            channel: 'email',
            optIn: false,
            submitted: date,
            privacyPolicyVersionId: '1',
            marketingChannelVersionId: '2',
          },
          {
            channel: 'post',
            optIn: false,
            submitted: date,
            privacyPolicyVersionId: '1',
            marketingChannelVersionId: '2',
          },
        ],
      };

      try {
        await this.customer.register(data);
        await this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'signup');
        this.onClose();
        this.showSuccessToast(translateService.instant('popins.signup.success'));
      } catch (err) {
        this.showErrorToast(err);
        logError(err);
        document.querySelector('ng-casto-modals').scrollTo({ top: 0, behavior: 'smooth' });
        this.globalError = err;
      } finally {
        this.isLoading = false;
      }
    } else {
      document.querySelector('ng-casto-modals').scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  async sendStatistic(isPremium: boolean) {
    const statisticService = this.injector.get(StatisticService);
    const premiumMap = {
      [StatisticTypeEnum.NEW_FREE_CARD_RELATION_CLIENT]: StatisticTypeEnum.NEW_PREMIUM_CARD_RELATION_CLIENT,
      [StatisticTypeEnum.NEW_FREE_CARD_RECHERCHE_CLIENT]: StatisticTypeEnum.NEW_PREMIUM_CARD_RECHERCHE_CLIENT,
      [StatisticTypeEnum.NEW_FREE_CARD_VALIDATION]: StatisticTypeEnum.NEW_PREMIUM_CARD_VALIDATION,
    };

    if (isPremium && this.statisticType in premiumMap) {
      this.statisticType = premiumMap[this.statisticType];
    }

    if (!this.statisticType && isPremium) {
      this.statisticType = StatisticTypeEnum.NEW_PREMIUM_CARD_RELATION_CLIENT;
    }

    if (!this.statisticType) {
      this.statisticType = StatisticTypeEnum.NEW_FREE_CARD_RELATION_CLIENT;
    }

    await statisticService.sendStatistic(this.statisticType, 1, this.customer.context);
  }

  async createFidelityCard() {
    const fidelityService = this.injector.get(FidelityService);
    const translateService = this.injector.get(TranslateService);
    this.isLoading = true;
    let input: AddFidelityCardCustomer = this.buildAddFidelityCardCustomerInput();
    try {
      let newCustomerInfo: InfoReturnCreateFidelityCard = await fidelityService.createFidelityCard(input);
      await this.loadCustomerCreatedWithFidelityCard(newCustomerInfo);
      if (this.cardIsPremium) {
        await this.showPaytweakQrCode(newCustomerInfo);
      } else {
        this.notifyFidelityCardCreated(newCustomerInfo);
        this.onClose();
        this.showSuccessToast(translateService.instant('popins.signup.success_create_card'));
      }
      await this.sendStatistic(input.cardIsPremium);
    } catch (err) {
      logError(err);
      this.showErrorToast(err);
    } finally {
      this.isLoading = false;
    }
  }

  private async loadCustomerCreatedWithFidelityCard(newCustomerInfo: InfoReturnCreateFidelityCard): Promise<void> {
    if (!newCustomerInfo?.customerId) {
      return;
    }

    const wasKnownCustomer = !!this.customerInfo;
    await this.customer.loadUserByKfId(newCustomerInfo.customerId);

    if (!wasKnownCustomer && this.customer.userDatas?.id) {
      await this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'signup');
    }
  }

  private notifyFidelityCardCreated(newCustomerInfo: InfoReturnCreateFidelityCard): void {
    const customerId = this.customer.userDatas?.id ?? newCustomerInfo?.customerId;
    if (customerId) {
      this.fidelitySubscribeStoreService.cardCreated$.next(customerId);
    }
  }

  private updateCurrentCustomerAddress(input: AddFidelityCardCustomer) {
    if (!this.customer.userDatas) {
      return;
    }
    this.customer.userDatas.address = {
      num: input.houseNumber,
      line1: input.address,
      line2: '',
      complement: input.localityPoBox,
      postalCode: input.postalCode,
      city: input.city,
      country: input.country,
    };
  }

  buildPaytweakRequestInput(newCustomerInfo: InfoReturnCreateFidelityCard): PaytweakRequestInput {
    let input: PaytweakRequestInput = {
      customerId: newCustomerInfo.customerId,
      cardNumber: newCustomerInfo.cardNumber,
      firstname: this.form.get('lastName').value,
      lastname: this.form.get('firstName').value,
      address: this.form.get('address').value,
      postalCode: this.form.get('postalCode').value,
      city: this.form.get('city').value,
      country: this.form.get('country').value,
      phone: this.form.get('phoneNumber').value,
      email: this.form.get('email').value,
    };

    return input;
  }

  setupReturnToSearch(isSearchUntilFind: boolean = true) {
    this.modalService.currentDatas.inputEmail = this.form.get('email').value;
    this.modalService.currentDatas.isSearchUntilFind = isSearchUntilFind;
  }

  async showPaytweakQrCode(newCustomerInfo: InfoReturnCreateFidelityCard) {
    if (!(await this.featureSettingsService.isFidelityEnabled())) {
      return;
    }

    this.setupReturnToSearch();
    let input: PaytweakRequestInput = this.buildPaytweakRequestInput(newCustomerInfo);
    this.modalService.display(MODAL.FIDELITY_PAYMENT_QRCODE, {
      paytweakRequestInput: input,
      refreshValidationRequested: this.refreshValidationRequested,
      onCloseCallback: this.registerCallback,
    });
  }

  async update() {
    if (!(await this.featureSettingsService.isFidelityEnabled())) {
      this.onClose(false);
      return;
    }

    const fidelityService = this.injector.get(FidelityService);
    const translateService = this.injector.get(TranslateService);
    this.isLoading = true;
    let input: UpdateCustomerComplete = this.buildUpdateCustomerInput();
    try {
      await fidelityService.updateCustomerFidelity(input);

      this.updateCurrentCustomerAddress(input);
      if (this.cardIsPremium) {
        let newCustomerInfo: InfoReturnCreateFidelityCard = {
          cardNumber: this.modalService.currentDatas.cardNumber,
          customerId: this.customerInfo.kfId,
        };
        await this.showPaytweakQrCode(newCustomerInfo);
        this.injector
          .get(StatisticService)
          .sendStatistic(StatisticTypeEnum.UPGRADE_PREMIUM_CARD_VALIDATION, 1, this.customer.context);
      } else {
        this.onClose();
        this.showSuccessToast(translateService.instant('popins.signup.success_update'));
      }
    } catch (err) {
      logError(err);
      this.showErrorToast(err);
    } finally {
      this.isLoading = false;
    }
  }

  showErrorToast(msg: string) {
    this.scrollToTop();
    const toastService = this.injector.get(ToastService);
    const translateService = this.injector.get(TranslateService);
    toastService.showErrorToast(translateService.instant('popins.signup.error_title'), msg, this.KEY_TOAST);
  }

  showSuccessToast(msg: string) {
    const toastService = this.injector.get(ToastService);
    const translateService = this.injector.get(TranslateService);
    toastService.showSuccessToast(translateService.instant('popins.signup.success_title'), msg, this.KEY_TOAST);
  }

  scrollToTop() {
    document.querySelector('ng-casto-modals').scrollTo({ top: 0, behavior: 'smooth' });
  }
}
